import { commonStepConfig } from './definitions'
import { TourStep } from './types'

export const enrichStep = (step: TourStep) => ({
  ...commonStepConfig,
  ...step,
})

export const enrichSteps = (steps: TourStep[]) => steps.map(enrichStep)
